"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentSlot = void 0;
var EquipmentSlot;
(function (EquipmentSlot) {
    EquipmentSlot["Body"] = "body";
    EquipmentSlot["Head"] = "head";
    EquipmentSlot["MainHand"] = "main-hand";
    EquipmentSlot["OffHand"] = "off-hand";
})(EquipmentSlot || (exports.EquipmentSlot = EquipmentSlot = {}));
